import { createContext } from "react";
const ImageBannerContext = createContext({});
export default ImageBannerContext;
